module.exports = __webpack_public_path__ + "static/img/payment-visa.4c441d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/payment-visa.png
// module id = D/nu
// module chunks = 0